import { useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";
import {
  AbsoluteDiv,
  CircularDiv,
  CustomDiv,
  HorizontalCenterDiv,
} from "../divs";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

interface ImageCarouselProps {
  images: { link: string; name: string; type?: string }[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const numOfImages = images.length;
  const [selectedImage, setSelectedImage] = useState(0);
  const updateNotificationRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (updateNotificationRef.current) {
      updateNotificationRef.current.animate(
        {
          opacity: [0.2, 1],
        },
        1500,
      );
    }
  }, [selectedImage]);
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (selectedImage == images.length - 1) {
        setSelectedImage(0);
      } else {
        setSelectedImage((prevState) => prevState + 1);
      }
    },
    onSwipedRight: () => {
      if (selectedImage == 0) {
        setSelectedImage(images.length - 1);
      } else {
        setSelectedImage((prevState) => prevState - 1);
      }
    },
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedImage((prev) => (prev + 1) % numOfImages);
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedImage]);

  const getImageUrl = () => {
    if (images[selectedImage].link) {
      if (!images[selectedImage].link.includes("cdn.filestackcontent.com")) {
        return (
          images[selectedImage].link +
          `?height=${"375"}&format=webp&quality=100`
        );
      }
      return images[selectedImage].link.replace(
        "https://cdn.filestackcontent.com/",
        `https://cdn.filestackcontent.com/resize=height:${"375"}/`,
      );
    }
  };

  return (
    <CustomDiv
      {...handlers}
      //@ts-ignore
      ref={updateNotificationRef}
      className="fade-in-image img-carousel-container"
      key={images[0].name}
      width={"480px"}
      height={"390px"}
      style={{
        backgroundImage: "url(" + getImageUrl() + ")",
      }}
    >
      <AbsoluteDiv bottom="10px" width="100%">
        <HorizontalCenterDiv style={{ gap: "10px" }}>
          {numOfImages > 1 &&
            Array.from({ length: numOfImages }).map((_, index) => (
              <CircularDiv
                key={index}
                width="12px"
                height="12px"
                background={
                  index == selectedImage ? PRIMARY_BUTTON_COLOR : "#D9D9D980"
                }
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedImage(index)}
              />
            ))}
        </HorizontalCenterDiv>
      </AbsoluteDiv>
    </CustomDiv>
  );
};

export default ImageCarousel;
